import React, { useEffect } from "react";
import { Grid, Card, Switch, Tooltip } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const DepositReportPermissionCard = (props) => {
  const { modules, setModules } = props;
  
  useEffect(() => {
    if (modules.Deposit_Report_view === undefined) {
      setModules((prevModules) => ({
        ...prevModules,
        Deposit_Report_view: true,
      }));
    }
  }, [modules, setModules]);


  const handleDepositReportViewChange = (event) => {
    const isDepositReportViewEnabled = event.target.checked;
    setModules({
      ...modules,
      Deposit_Report_view: isDepositReportViewEnabled,
    });
  };

  return (
    <>
      <Card sx={{ minWidth: 275, boxShadow: 3, width: 'inherit' }}>
        <MDBox p={2}>
          <Grid container spacing={1}>
            <Grid item lg={12} md={12} xs={12} container alignItems="center">
              <MDTypography
                color="dark"
                display="block"
                variant="subtitle2"
                fontWeight="bold"
                sx={{ flex: 1 }}
              >
                Deposit Report Module
              </MDTypography>
              
              <Tooltip
                title={`${
                  modules.Deposit_Report_view ? "Disable" : "Enable"
                } Deposit Report module`}
                placement="top"
              >
                <Switch
                  checked={modules.Deposit_Report_view || false}
                  onChange={handleDepositReportViewChange}
                />
              </Tooltip>
            </Grid>
           
          </Grid>
        </MDBox>
      </Card>
    </>
  );
};

export default DepositReportPermissionCard;
